/* eslint-disable @typescript-eslint/no-var-requires */

const CONFIG_FILE = 'breakpoints.ts';

// Refers to the default breakpoint decided here: https://www.notion.so/grebban/Breakpoints-cc8a13ef3c494abeb8b1acce9e2ea13f
const DEFAULT_BREAKPOINTS = ['0em', '22.5em', '48em', '64em', '80em', '85.375em', '96em', '120em'];

const getBreakpoints = () => {
    try {
        const projectBreakpoints = require(`${process.env.REACT_APP_CONFIG_DIRECTORY_PATH}/${CONFIG_FILE}`);
        return (projectBreakpoints || {}).breakpointValues || DEFAULT_BREAKPOINTS;
    } catch (e) {
        if (process.env.NODE_ENV === 'development') {
            console.log('Project specific breakpoints could not be imported into "@grebban/style-system-react":');
            console.log(
                `"breakpointValues" was not found in ${process.env.REACT_APP_CONFIG_DIRECTORY_PATH}/${CONFIG_FILE}`,
            );
        }
        return DEFAULT_BREAKPOINTS;
    }
};

export default getBreakpoints;
